import {
  ActionContainer,
  FormContainer,
  Title,
} from "./InventoryUpdatesStyles";
import React, { SyntheticEvent, useRef, useState } from "react";
import Modal from "../../../common/Modal";
import ModalContentWithCloseButton from "../../../common/ModalContentWithCloseButton";
import UpdateContainerLocation from "../../../component-search/PartDrawer/Inventory/PhysicalInventory/UpdateContainerLocation";
import Button from "../../../common/Button";
import { ButtonTypes } from "../../../common/Button/constants";
import useTriggerSounds from "../../../../utils/hooks/sounds";
import { useStringInput } from "../../../../utils/hooks/inputs";
import FormLine from "../../../common/FormLine";

export enum ItemType {
  PARTS_CONTAINERS = "containers",
  INVENTORY_ITEMS = "items",
}
export default function MoveContainerAction({
  itemType,
}: {
  itemType: ItemType;
}) {
  const [containerToMove, setContainerToMove] = useState<string | null>(null);
  const moveContainerInputRef = useRef<HTMLInputElement>(null);
  const {
    value: containerBarcode,
    reset: resetContainerBarcode,
    bind: bindContainerBarcode,
  } = useStringInput("");
  const { triggerBadSound } = useTriggerSounds();

  const focusOnInput = () => {
    if (moveContainerInputRef.current !== null) {
      moveContainerInputRef.current.value = "";
      moveContainerInputRef.current.focus();
    }
  };

  const closeModal = () => {
    setContainerToMove(null);
    focusOnInput();
    resetContainerBarcode();
  };

  const submitContainerBarcode = (event: SyntheticEvent) => {
    event.preventDefault();
    if (containerBarcode) {
      setContainerToMove(containerBarcode.trim());
    } else {
      triggerBadSound();
    }
  };

  const getTitleText = () => {
    if (itemType === ItemType.INVENTORY_ITEMS) {
      return "Move inventory item";
    } else {
      return "Move container";
    }
  };

  return (
    <>
      <ActionContainer>
        <Title>{getTitleText()}</Title>
        <FormContainer onSubmit={submitContainerBarcode}>
          <FormLine
            name="containerBarcode"
            label="Container barcode"
            placeholder={"Scan code or enter manually"}
            isRequired={true}
            bind={bindContainerBarcode}
            ref={moveContainerInputRef}
          />
          <Button label={"Move"} type={ButtonTypes.SUBMIT} centerText />
        </FormContainer>
      </ActionContainer>
      {containerToMove && (
        <Modal isOpen onRequestClose={closeModal}>
          <ModalContentWithCloseButton closeModal={closeModal}>
            <UpdateContainerLocation
              selectedContainers={[containerToMove]}
              itemType={itemType}
              onCancel={closeModal}
              onFinishedEditing={closeModal}
            />
          </ModalContentWithCloseButton>
        </Modal>
      )}
    </>
  );
}
